import { fetchApi } from '@/config/axiosSetting';
import {
  DeleteDamagedAdjusterAttachedImagesPropsType,
  DeleteDamagedAdjusterAttachedImagesQueryParamsType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/deleteDamagedAdjusterAttachedImages/deleteDamagedAdjusterAttachedImagesQuery.type';
import { AdditionalApiUrlCreator } from '@/modules/adjusterReportModules/IncidentParticipants/utils/AdditionalApiUrlCreator';

export const deleteDamagedAdjusterAttachedImagesFunction = ({
  damagedId,
  data,
  fileType,
  id,
  type,
}: DeleteDamagedAdjusterAttachedImagesQueryParamsType &
  DeleteDamagedAdjusterAttachedImagesPropsType) => {
  const postData = new FormData();
  postData.append('image_id', data.image_id);

  const url = AdditionalApiUrlCreator({
    id,
    TabType: type,
    userType: fileType,
  });

  return fetchApi({
    method: 'DELETE',
    url,
    data: postData,
    params: fileType === 'damaged' ? { damaged_id: damagedId } : undefined,
  });
};
